import type { RootState } from "src/redux/root-reducer";

export function getState(state: RootState) {
  return state;
}
